import React, { useEffect, useRef, useState } from "react";
import * as d3 from "d3";
import { TfiTarget } from "react-icons/tfi";
import { averageSimple, standardDeviation } from 'simple-statistics';
import { isMobile } from "../app/utils";

interface DataPoint {
  x: Date;
  y: number;
  label?: string;
}

interface ToolTip {
  xPosition: number,
  yPosition: number,
  xValue: Date,
  yValue: number,
  side: "right" | "left",
}

const testData: DataPoint[] = [
  { x: new Date(2025, 0, 1), y: 10 },
  { x: new Date(2025, 0, 2), y: 9.7 },
  { x: new Date(2025, 0, 3), y: 9.61 },
  { x: new Date(2025, 0, 4), y: 9.3 },
  { x: new Date(2025, 0, 5), y: 9.29 },
  { x: new Date(2025, 0, 6), y: 9.48 },
  { x: new Date(2025, 0, 7), y: 9.36 },
  { x: new Date(2025, 0, 8), y: 9.96 },
  { x: new Date(2025, 0, 9), y: 9.47 },
  { x: new Date(2025, 0, 10), y: 9.61 },
  { x: new Date(2025, 0, 11), y: 9.44 },
  { x: new Date(2025, 0, 12), y: 9.26 },
  { x: new Date(2025, 0, 13), y: 9.25 },
  { x: new Date(2025, 0, 14), y: 9.56 },
  { x: new Date(2025, 0, 15), y: 9.45 },
  { x: new Date(2025, 0, 16), y: 9.05 },
  { x: new Date(2025, 0, 17), y: 9.33 },
  { x: new Date(2025, 0, 18), y: 9.87 },
  { x: new Date(2025, 0, 19), y: 10.29 },
  { x: new Date(2025, 0, 20), y: 9.83 },
  { x: new Date(2025, 0, 21), y: 9.53 },
  { x: new Date(2025, 0, 22), y: 9.93 },
  { x: new Date(2025, 0, 23), y: 10.11 },
  { x: new Date(2025, 0, 24), y: 10.35 },
  { x: new Date(2025, 0, 25), y: 10.9 },
  { x: new Date(2025, 0, 26), y: 11.31 },
  { x: new Date(2025, 0, 27), y: 11.38 },
  { x: new Date(2025, 0, 28), y: 10.93 },
  { x: new Date(2025, 0, 29), y: 11.4 },
  { x: new Date(2025, 0, 30), y: 11.74 },
  { x: new Date(2025, 0, 31), y: 12.15 },
  { x: new Date(2025, 1, 1), y: 12.51 },
  { x: new Date(2025, 1, 2), y: 12.48 },
  { x: new Date(2025, 1, 3), y: 12.79 },
  { x: new Date(2025, 1, 4), y: 13.17 },
  { x: new Date(2025, 1, 5), y: 13.51 },
  { x: new Date(2025, 1, 6), y: 13.63 },
  { x: new Date(2025, 1, 7), y: 13.09 },
  { x: new Date(2025, 1, 8), y: 13 },
  { x: new Date(2025, 1, 9), y: 12.78 },
  { x: new Date(2025, 1, 10), y: 12.36 },
  { x: new Date(2025, 1, 11), y: 12.92 },
  { x: new Date(2025, 1, 12), y: 13.46 },
  { x: new Date(2025, 1, 13), y: 14.13 },
  { x: new Date(2025, 1, 14), y: 13.82 },
  { x: new Date(2025, 1, 15), y: 13.44 },
  { x: new Date(2025, 1, 16), y: 13.17 },
  { x: new Date(2025, 1, 17), y: 13.26 },
  { x: new Date(2025, 1, 18), y: 13.15 },
  { x: new Date(2025, 1, 19), y: 13.43 },
  { x: new Date(2025, 1, 20), y: 14.09 },
  { x: new Date(2025, 1, 21), y: 14.08 },
  { x: new Date(2025, 1, 22), y: 14.98 },
  { x: new Date(2025, 1, 23), y: 14.27 },
  { x: new Date(2025, 1, 24), y: 14.18 },
  { x: new Date(2025, 1, 25), y: 13.85 },
  { x: new Date(2025, 1, 26), y: 13.59 },
  { x: new Date(2025, 1, 27), y: 14.47 },
  { x: new Date(2025, 1, 28), y: 13.99 },
  { x: new Date(2025, 2, 1), y: 13.84 },
  { x: new Date(2025, 2, 2), y: 14.76 },
  { x: new Date(2025, 2, 3), y: 15.01 },
  { x: new Date(2025, 2, 4), y: 14.66 },
  { x: new Date(2025, 2, 5), y: 15.66 },
  { x: new Date(2025, 2, 6), y: 15.18 },
  { x: new Date(2025, 2, 7), y: 16.16 },
  { x: new Date(2025, 2, 8), y: 15.57 },
  { x: new Date(2025, 2, 9), y: 15.12 },
  { x: new Date(2025, 2, 10), y: 14.57 },
  { x: new Date(2025, 2, 11), y: 13.86 },
  { x: new Date(2025, 2, 12), y: 13.35 },
  { x: new Date(2025, 2, 13), y: 12.8 },
  { x: new Date(2025, 2, 14), y: 12.25 },
  { x: new Date(2025, 2, 15), y: 12.76 },
  { x: new Date(2025, 2, 16), y: 13.47 },
  { x: new Date(2025, 2, 17), y: 13.75 },
  { x: new Date(2025, 2, 18), y: 13.29 },
  { x: new Date(2025, 2, 19), y: 13.55 },
  { x: new Date(2025, 2, 20), y: 13.03 },
  { x: new Date(2025, 2, 21), y: 12.48 },
  { x: new Date(2025, 2, 22), y: 12.62 },
  { x: new Date(2025, 2, 23), y: 12.19 },
  { x: new Date(2025, 2, 24), y: 12.58 },
  { x: new Date(2025, 2, 25), y: 13.4 },
  { x: new Date(2025, 2, 26), y: 14.11 },
  { x: new Date(2025, 2, 27), y: 14.79 },
  { x: new Date(2025, 2, 28), y: 14.52 },
  { x: new Date(2025, 2, 29), y: 14.57 },
  { x: new Date(2025, 2, 30), y: 15.51 },
  { x: new Date(2025, 2, 31), y: 15.35 },
  { x: new Date(2025, 3, 1), y: 16.00 },
];

const ElectricLineChart: React.FC<{
  originalData?: DataPoint[],
  description?: string,
  xDescription?: string,
  yDescription?: string
}> = ({
  originalData = testData,
  description = "P/L TEST3",
  xDescription = "Data",
  yDescription = "P/L"
}) => {
    const ref = useRef<SVGSVGElement | null>(null);
    const [toolTip, setToolTip] = useState<ToolTip | null>(null);
    const [showToolTipOpacity, setShowToolTipOpacity] = useState<boolean>(false);
    const [showToolTipVisible, setShowToolTipVisible] = useState<boolean>(false);
    const [touchMoving, setTouchMoving] = useState(false);
    const [touchTimeout, setTouchTimeout] = useState<NodeJS.Timeout | undefined>(undefined);
    const [zScoreEnabled, setZScoreEnabled] = useState(false);
    const [data, setData] = useState(originalData);
    useEffect(() => {
      if (zScoreEnabled) {
        const values = originalData.map(dataPoint => dataPoint.y);
        const average = averageSimple(values);
        const stdDeviation = standardDeviation(values);
        setData(originalData.map((dataPoint, index) => {
          return {
            x: dataPoint.x,
            y: Math.round((dataPoint.y - average) / stdDeviation * 100) / 100,
            label: dataPoint.label,
          } as DataPoint;
        }));
      } else {
        setData(originalData);
      }
    }, [originalData, zScoreEnabled])

    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0);

    const [minX, setMinX] = useState(new Date());
    const [maxX, setMaxX] = useState(new Date());

    const [minY, setMinY] = useState(0);
    const [maxY, setMaxY] = useState(0);

    const [marginMinX, setMarginMinX] = useState(new Date());
    const [marginMaxX, setMarginMaxX] = useState(new Date());

    const [marginMinY, setMarginMinY] = useState(0);
    const [marginMaxY, setMarginMaxY] = useState(0);

    useEffect(() => {
      if (!ref.current || !data) return;

      const lineToAxisMargin = 0.05;

      const minValueX = Math.min(...data.map(dataPoint => dataPoint.x.valueOf()));
      const maxValueX = Math.max(...data.map(dataPoint => dataPoint.x.valueOf()));

      const minX = new Date(minValueX);
      const maxX = new Date(maxValueX);
      const marginMinX = new Date(minValueX - (maxValueX - minValueX) * lineToAxisMargin);
      const marginMaxX = new Date(maxValueX + (maxValueX - minValueX) * lineToAxisMargin);

      const zScoreAbsMax = zScoreEnabled ? Math.trunc(data.map(dataPoint => dataPoint.y).reduce((prev, cur) => Math.max(prev, Math.abs(cur)), 0)) + 1 : 0;
      const minY = zScoreEnabled ? -zScoreAbsMax : Math.min(...data.map(dataPoint => dataPoint.y));
      const maxY = zScoreEnabled ? zScoreAbsMax : Math.max(...data.map(dataPoint => dataPoint.y));
      const marginMinY = minY - (maxY - minY) * lineToAxisMargin;
      const marginMaxY = maxY + (maxY - minY) * lineToAxisMargin;

      setMinX(minX);
      setMaxX(maxX);

      setMarginMinX(marginMinX);
      setMarginMaxX(marginMaxX);

      setMinY(minY);
      setMaxY(maxY);

      setMarginMinY(marginMinY);
      setMarginMaxY(marginMaxY);

      // 🔹 Lê o tamanho real do SVG definido pelo Tailwind
      const { width, height } = ref.current.getBoundingClientRect();
      setWidth(width);
      setHeight(height);

      const svg = d3.select(ref.current);

      // 🔹 Escalas
      const xScaleLine = d3.scaleTime()
        .domain([marginMinX, maxX])
        .range([0.1 * width, 0.9 * width]);
      const yScaleLine = d3.scaleLinear()
        .domain([marginMinY, marginMaxY])
        .range([0.9 * height, 0.1 * height]);

      // 🔹 Linha
      const line = d3.line<DataPoint>()
        .x(d => xScaleLine(d.x))
        .y(d => yScaleLine(d.y))
        .curve(d3.curveCatmullRom.alpha(0.5));

      const existingLine = svg.select(".line");

      if (existingLine.empty()) {
        svg.selectAll("*").remove();
        svg
          .attr("width", width)
          .attr("height", height);

        const defs = svg.append("defs");

        // 🔹 Gradiente que se move ao longo da linha
        const lineGradient = defs.append("linearGradient")
          .attr("id", "lineGradient")
          .attr("x1", "0%")
          .attr("y1", "0%")
          .attr("x2", "100%")
          .attr("y2", "0%");

        // stops fixos, mas com offset animado
        lineGradient.append("stop")
          .attr("offset", "0%")
          .attr("stop-color", "#60a5fa");

        lineGradient.append("stop")
          .attr("offset", "70%")
          .attr("stop-color", "#bfdbfe");

        lineGradient.append("stop")
          .attr("offset", "80%")
          .attr("stop-color", "#ffffff");

        lineGradient.append("stop")
          .attr("offset", "95%")
          .attr("stop-color", "#ffffff");

        lineGradient.append("stop")
          .attr("offset", "100%")
          .attr("stop-color", "#60a5fa");

        // animação para deslocar o gradiente
        lineGradient.append("animateTransform")
          .attr("attributeName", "gradientTransform").attr("id", "wave")
          .attr("type", "translate")
          .attr("from", "-1 0")
          .attr("to", "2 0")
          .attr("begin", "1s")
          .attr("dur", "5s")
          .attr("repeatCount", "indefinite");

        // 🔹 Filtro de brilho
        const glow = defs.append("filter").attr("id", "glow");
        glow.append("feGaussianBlur")
          .attr("in", "SourceGraphic")
          .attr("stdDeviation", "1.5")
          .attr("result", "blur")
          .append("animate")
          .attr("attributeName", "stdDeviation")
          .attr("values", "1.5;3;2;1.5;1.5;1.5")
          .attr("begin", "1s")
          .attr("dur", "5s")
          .attr("repeatCount", "indefinite");

        glow.append("feMerge")
          .selectAll("feMergeNode")
          .data(["blur", "SourceGraphic", "blur"])
          .enter()
          .append("feMergeNode")
          .attr("in", d => d);

        // Cria o a linha svg
        svg.append("path")
          .datum(data)
          .attr("class", "line")
          .attr("d", line)
          .attr("fill", "none")
          .attr("stroke", "url(#lineGradient)")
          .attr("stroke-width", 1)
          .attr("filter", "url(#glow)");

        // 🔹 Inicializa os eixos X e Y
        const xScaleAxis = d3.scaleTime()
          .domain([marginMinX, marginMaxX])
          .range([0.1 * width, (0.9 + lineToAxisMargin) * width]);
        const xAxis = d3.axisBottom(xScaleAxis)
          .ticks(0)
          .tickSizeOuter(0);
        const yScaleAxis = d3.scaleLinear()
          .domain([marginMinY, marginMaxY])
          .range([0.9 * height, 0.1 * height]);
        const yAxis = d3.axisLeft(yScaleAxis)
          .ticks(5)
          .tickSize(6)
          .tickSizeOuter(0);

        svg.append("g")
          .attr("transform", "translate(0," + 0.9 * height + ")")
          .attr("class", "myXaxis")
          .call(xAxis);

        svg.append("g")
          .attr("transform", "translate(" + 0.1 * width + ", 0)")
          .attr("class", "myYaxis")
          .call(yAxis);

        svg.selectAll(".myYaxis, .myXaxis")
          .style("stroke", "#d4d4d4")
          .style("font-size", isMobile() ? "11px" : "14px")
          .style("font-weight", "100")
          .style("font-family", "Arial");
      } else {
        // Atualiza a linha svg existente com novos dados
        existingLine
          .datum(data)
          .transition() // opcional, para animação
          .duration(1000)
          .attr("d", line);

        // Atualiza o eixo Y
        const yScaleAxis = d3.scaleLinear()
          .domain([marginMinY, marginMaxY])
          .range([0.9 * height, 0.1 * height]);
        const yAxisChangeScale = d3.axisLeft(yScaleAxis)
          .ticks(zScoreEnabled ? zScoreAbsMax * 2 : 5)
          .tickSize(zScoreEnabled ? (-0.85 * width) : 6)
          .tickSizeOuter(0)
          .tickFormat(d => (!zScoreEnabled && d === 0) ? "0" : !zScoreEnabled ? `${d3.format("d")(d)} σ` : `${d3.format("d")(d)}`);
        svg.select(".myYaxis")
          .transition()
          .duration(1000)
          .call(yAxisChangeScale as any);
        const yAxisChangeFormat = yAxisChangeScale
          .tickFormat(d => (zScoreEnabled && d === 0) ? "0" : zScoreEnabled ? `${d3.format("d")(d)} σ` : `${d3.format("d")(d)}`);
        svg.select(".myYaxis")
          .transition()
          .delay(900)
          .duration(100)
          .call(yAxisChangeFormat as any);
        svg.selectAll(".myYaxis .tick line")
          .transition()
          .duration(1000)
          .style("stroke", zScoreEnabled ? "RGBA(252, 252, 252, 0.2)" : "#d4d4d4");

        // Atualiza o eixo x
        svg.select(".myXaxis")
          .transition()
          .duration(1000)
          .attr("transform", "translate(0," + (zScoreEnabled ? (0.5 * height) : (0.9 * height)) + ")")

        svg.select(".myXaxis")
          .selectAll("*")
          .transition()
          .duration(1000)
          .style("stroke", zScoreEnabled ? "RGBA(0, 0, 0, 0)" : "#d4d4d4");
      }
    }, [data, zScoreEnabled]);

    function chartMouseMove(event: React.MouseEvent<any>): void {
      try {
        const rect = ref.current!.getBoundingClientRect();
        const px = event.clientX - rect.left;
        setToolTipValues(px);
        setTouchMoving(true);
        setShowToolTipVisible(true);
        setTimeout(() => {
          setShowToolTipOpacity(true);
        }, 200);
      } catch (e) {
        console.log(e);
      }
    }

    // function iconTargetMouseEventHandler(event: React.MouseEvent<SVGElement>): void {
    //   if (touchTimeout) {
    //     clearTimeout(touchTimeout);
    //     setTouchTimeout(undefined);
    //   }
    //   event.preventDefault();
    // }

    function chartTouchStart(event: React.TouchEvent<SVGElement>): void {
      try {
        const rect = ref.current!.getBoundingClientRect();
        const px = event.changedTouches[0].clientX - rect.left;
        setToolTipValues(px);
        setTouchMoving(false);
        if (touchTimeout) {
          clearTimeout(touchTimeout);
          setTouchTimeout(undefined);
        }
        setShowToolTipVisible(true);
        setShowToolTipOpacity(true);
        const timeout = setTimeout(() => {
          setTouchMoving(false);
          setShowToolTipOpacity(false);
          setTimeout(() => {
            setShowToolTipVisible(false);
          }, 200)
        }, 1500);
        setTouchTimeout(timeout);
      } catch (e) {
        console.log(e);
      }
    }

    function chartTouchMove(event: React.TouchEvent<SVGElement>): void {
      try {
        const rect = ref.current!.getBoundingClientRect();
        const px = event.changedTouches[0].clientX - rect.left;
        setToolTipValues(px);
        setTouchMoving(true);
        if (touchTimeout) {
          clearTimeout(touchTimeout);
          setTouchTimeout(undefined);
        }
        setShowToolTipVisible(true);
        setShowToolTipOpacity(true);
      } catch (e) {
        console.log(e);
      }
    }

    function setToolTipValues(clientPositionX: number) {
      try {
        const xScaleLine = d3.scaleTime()
          .domain([marginMinX, maxX])
          .range([0.1 * width, 0.9 * width]);
        const yScaleLine = d3.scaleLinear()
          .domain([marginMinY, marginMaxY])
          .range([0.9 * height, 0.1 * height]);
        const xValueProxy = xScaleLine?.invert(clientPositionX);
        const dataPoint = data.findLast(d => d.x.valueOf() <= xValueProxy.valueOf()) ?? data[0];
        const xValue = dataPoint?.x;
        const yValue = dataPoint?.y;
        const xPosition = xScaleLine(xValue);
        const yPosition = yScaleLine(yValue);
        const side = clientPositionX > xScaleLine.range().reduce((prev, cur) => prev + cur, 0) / 2 ? "left" : "right";
        setToolTip({
          xPosition,
          yPosition,
          xValue,
          yValue,
          side,
        });
      } catch (e) {
        console.log(e);
      }
    }

    function chartTouchEnd(event: any): void {
      try {
        if (touchMoving) {
          setTouchMoving(false);
          const timeout = setTimeout(() => {
            setShowToolTipOpacity(false);
            setTimeout(() => {
              setShowToolTipVisible(false);
            }, 200)
          }, isMobile() ? 1500 : 100);
          setTouchTimeout(timeout);
        }
      } catch (e) {
        console.log(e);
      }
    }

    return (
      <div className="relative flex flex-col h-52 lg:h-80 w-full lg:w-1/3 rounded-md m-10 p-5 pt-2.5 text-neutral-300 select-none bg-black/10 border lg:border-2 border-blue-300/40 shadow-2xl shadow-slate-900/80">
        <div className="text-center text-sm font-semibold">
          {description}
        </div>

        <div className="relative flex flex-col w-full h-full" onMouseLeave={isMobile() ? () => { } : chartTouchEnd}>
          <svg ref={ref} className="absolute w-full h-full" onMouseMove={chartMouseMove} onTouchStart={chartTouchStart} onTouchMove={chartTouchMove} onTouchEnd={chartTouchEnd} onTouchCancel={chartTouchEnd}></svg>
          <TfiTarget
            onMouseMove={chartMouseMove}
            size={isMobile() ? 15 : 18}
            style={{ top: `${toolTip?.yPosition?.toFixed(0)}px`, left: `${toolTip?.xPosition?.toFixed(0)}px` }}
            className={`absolute font-extrabold text-orange-200 -translate-x-1/2 -translate-y-1/2 transition-opacity ease-in-out duration-200 ${showToolTipOpacity === false ? " opacity-0 " : " opacity-100 "} ${showToolTipVisible ? " " : " invisible "}`}
          />
          <div
            onMouseMove={chartMouseMove}
            style={{ left: `${toolTip?.xPosition?.toFixed(0)}px` }}
            className={`absolute top-1/2 -translate-y-1/2 ${toolTip?.side === "right" ? "translate-x-1/4" : "-translate-x-[125%]"} p-3 rounded-xl min-w-28 w-fit h-fit flex flex-col border border-x-neutral-200/50 border-y-2 border-y-neutral-200/70 backdrop-blur-sm transition-all ease-in-out duration-100 ${showToolTipOpacity === false ? " opacity-0 " : " opacity-100 "} ${showToolTipVisible ? " " : " invisible "}"`}>
            <div className="items-center text-center text-nowrap">
              <div className="flex text-center w-full">
                <TfiTarget className="w-full text-orange-200 text-xl lg:text-2xl" />
              </div>
              <div className="w-full text-sm lg:text-base underline underline-offset-4 pt-1.5">
                {xDescription}
              </div>
              <div className="w-full text-sm lg:text-base">
                {toolTip?.xValue?.toLocaleDateString()}
              </div>
              <div className="w-full text-sm lg:text-base underline underline-offset-4 pt-1.5">
                {zScoreEnabled ? "Desvios Padrões" : yDescription}
              </div>
              <div className="w-full text-sm lg:text-base">
                {zScoreEnabled ? (((toolTip?.yValue ?? 0) > 0 ? "+ " : "- ") + Math.abs(toolTip?.yValue ?? 0).toFixed(2) + " σ") : toolTip?.yValue?.toFixed(2)}
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col w-full items-center">
          <button onClick={() => { setZScoreEnabled(!zScoreEnabled); setShowToolTipVisible(false) }}
            className={`font-semibold ${zScoreEnabled ? "text-neutral-600 bg-white/70 hover:bg-white/90" : "text-neutral-500 bg-black/60 hover:bg-black/40 border-black/90"} rounded-lg px-3 py-1 mr-2`}>
            Z-Score
          </button>
        </div>
      </div>
    )
  };

export default ElectricLineChart;
